import { memo } from "react";
import { FormattedMessage } from "react-intl";
import Button, { BUTTON_SIZES, BUTTON_VARIANTS } from "app/pages/.shared/form/Button";
import "./ProductActionButtonMobile.scss";

const ProductActionButtonMobile = () => {
	return (
		<div className="product-action-button-mobile" data-testid="product-action-button-mobile">
			<Button
				variant={BUTTON_VARIANTS.FILLED}
				size={BUTTON_SIZES.LARGE}
				label={<FormattedMessage id="product.page.button.cta" />}
				to={{ pathname: "/booking/search" }}
				data-testid="check-availibility-mobile-cta"
			/>
		</div>
	);
};

export default memo(ProductActionButtonMobile);
